var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_12",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0.5H0.5V32.5H32.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0111 24.8111L23.3 19.5222C23.5771 19.2452 23.7977 18.9178 23.9619 18.54C24.1261 18.1622 24.2077 17.7593 24.2067 17.3311C24.2067 16.4748 23.9045 15.7444 23.3 15.14C22.6956 14.5356 21.9652 14.2333 21.1089 14.2333C20.6304 14.2333 20.1584 14.3718 19.693 14.6489C19.2276 14.9259 18.667 15.3918 18.0111 16.0467C17.2556 15.3415 16.6637 14.863 16.2356 14.6111C15.8074 14.3593 15.3667 14.2333 14.9134 14.2333C14.0571 14.2333 13.3267 14.5356 12.7223 15.14C12.1178 15.7444 11.8156 16.4748 11.8156 17.3311C11.8156 17.7593 11.8977 18.1622 12.0619 18.54C12.2261 18.9178 12.4462 19.2452 12.7223 19.5222L18.0111 24.8111ZM19.9 30.7044C19.3208 31.2837 18.603 31.5733 17.7467 31.5733C16.8904 31.5733 16.1726 31.2837 15.5934 30.7044L2.29559 17.4067C2.01855 17.1296 1.79793 16.8022 1.63373 16.4244C1.46952 16.0467 1.38792 15.6437 1.38893 15.2156V4.41111C1.38893 3.58 1.6851 2.86877 2.27746 2.27742C2.86981 1.68607 3.58104 1.38989 4.41115 1.38889H15.2156C15.6437 1.38889 16.0467 1.47099 16.4245 1.6352C16.8023 1.7994 17.1297 2.01952 17.4067 2.29555L30.7045 15.6311C31.2837 16.2104 31.5734 16.9221 31.5734 17.7663C31.5734 18.6105 31.2837 19.3217 30.7045 19.9L19.9 30.7044ZM17.7467 28.5889L28.5511 17.7844L15.2156 4.41111H4.41115V15.2156L17.7467 28.5889ZM8.18893 10.4556C8.81856 10.4556 9.35399 10.2354 9.79524 9.7952C10.2365 9.35496 10.4566 8.81952 10.4556 8.18889C10.4556 7.55926 10.2355 7.02432 9.79524 6.58409C9.355 6.14385 8.81956 5.92323 8.18893 5.92222C7.5593 5.92222 7.02436 6.14284 6.58413 6.58409C6.14389 7.02533 5.92327 7.56026 5.92226 8.18889C5.92226 8.81852 6.14288 9.35395 6.58413 9.7952C7.02537 10.2364 7.5603 10.4566 8.18893 10.4556Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.6856222515fbe1332e328f1872a09643.svg";
export { ForwardRef as ReactComponent };